import React from "react"
import { graphql, useStaticQuery } from "gatsby"
import { FormattedMessage, useIntl } from "react-intl"
import { WingsEyebrow, WingsStoryCard } from "@wingspans-ui"

/**
 * Roadmap featured stories section using the same WingsStoryCard component
 * used in the careers template.
 *
 * @returns {JSX.Element|null}
 */
const RoadmapFeaturedStories = () => {
  const { locale } = useIntl()

  const { allCosmicjsStories } = useStaticQuery(graphql`
    query RoadmapFeaturedStoriesQuery {
      allCosmicjsStories(
        filter: {
          metadata: {
            story_display_in_stories_week: { eq: true }
          }
        }
      ) {
        edges {
          node {
            id
            slug
            locale
            title
            type
            metadata {
              story_display_in_stories_week
              story_personal_photo {
                imgix_url
              }
              story_video_url
              story_job_title
              story_company
              story_quote
            }
          }
        }
      }
    }
  `)

  const featuredStories = allCosmicjsStories.edges
                                            .filter(edge => edge.node.locale === locale)
                                            .map(edge => edge.node)
                                            
  if (!featuredStories.length) {
    return null
  }

  return (
    <section
      className="roadmap-featured-stories w-container w-mb-4"
      id="roadmap-featured-stories-focus-target"
      tabIndex={-1}
      data-roadmap-content-region="featured-stories"
    >
      <div className="w-flex w-flex-column w-items-center w-my-2">
        <WingsEyebrow as="div" className="w-text-center">
          <FormattedMessage id="roadmap-featured-stories" defaultMessage="Featured Stories" />
        </WingsEyebrow>
      </div>

      <div className="w-full w-default-cards-container">
        {featuredStories.map((story) => (
          <WingsStoryCard
            key={story.id}
            img={story.metadata.story_personal_photo?.imgix_url}
            title={story.title}
            video={story.metadata.story_video_url}
            slug={story.slug}
            storyJobTitle={story.metadata.story_job_title}
            storyCompany={story.metadata.story_company}
            storyQuote={story.metadata.story_quote}
            objectID={`${story.slug}-${story.locale}`}
            contentType={story.type}
          />
        ))}
      </div>
    </section>
  )
}

export default RoadmapFeaturedStories
